import { fetchGestionMorasJson, normalizarAlertaCompromisos } from './gestionMorasApi';

export async function verificarGestionMoras() {
  try {
    const data = await fetchGestionMorasJson('/api/asesor/verificar-gestion-moras', {
      fallbackMessage: 'Error al verificar la gestión de moras',
    });

    return {
      tienePrestamosEnMora: Boolean(data.tiene_prestamos_en_mora),
      totalPrestamos: Number(data.total_prestamos ?? 0),
    };
  } catch (error) {
    console.error('Error al verificar la gestión de moras:', error);

    return {
      tienePrestamosEnMora: false,
      totalPrestamos: 0,
    };
  }
}

export async function getAlertaCompromisosLogin() {
  const data = await fetchGestionMorasJson('/api/asesor/gestion-moras/alerta-login', {
    fallbackMessage: 'Error al obtener la alerta de compromisos',
  });

  return normalizarAlertaCompromisos(data.data);
}

export async function getGestionMoras() {
  return fetchGestionMorasJson('/api/asesor/gestion-moras');
}

export async function createCompromisoPago(payload) {
  return fetchGestionMorasJson('/api/asesor/gestion-moras/compromiso-pagos', {
    method: 'POST',
    payload,
    fallbackMessage: 'Error al registrar el compromiso de pago',
  });
}